import { render, staticRenderFns } from "./CampoOrigenOferta.vue?vue&type=template&id=3f08690e"
import script from "./CampoOrigenOferta.vue?vue&type=script&lang=js"
export * from "./CampoOrigenOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports